import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-cpmDealsTypeShape",
  "use": "svg-icon-cpmDealsTypeShape-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-cpmDealsTypeShape\"><path d=\"M0 0v10h2.013L2 13.001 5 10h2v3.001h4L14 16v-2.999h2v-9h-3V0H0zm2 8h9V2H2v6z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol